<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="$route.name !== 'manageParticipationView'"
      v-model="drawer"
      dark
      app
      color="#2BA197"
    >
      <div
        class="ra-drawer-scrollbar"
        id="style-ra-drawer"
      >
        <v-list
          dense
          class="red_list"
        >
          <!-- <div style="display: flex; align-center: center; justify-content: center; padding: 0 4.5rem;">
            <v-img
              :src="require('@/assets/logo/logo-pmuc.png')"
              class="my-5"
              max-width="85"
            ></v-img>
          </div> -->
          <div class="name-logo pt-4 pb-2" style="display: flex; align-center: center; justify-content: center;">
            <p>Registration Authority</p>
          </div>
          <v-divider class="mx-13 mb-7" color="white"></v-divider>
          <template v-for="item in items">
            <v-row
              v-if="item.heading"
              :key="item.heading"
              align="center"
            >
              <v-col cols="6">
                <v-subheader v-if="item.heading">
                  {{ item.heading }}
                </v-subheader>
              </v-col>
              <v-col
                cols="6"
                class="text-center"
              >
                <a
                  href="#!"
                  class="body-2 black--text"
                >EDIT</a>
              </v-col>
            </v-row>
            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :append-icon="item.model ? item.iconAlt : item['iconAlt']"
              :prepend-icon="item.text ? item.icon : 'mdi-poll'"
            >
              <template v-slot:activator>
                <v-list-item-content class="ml-n6">
                  <v-list-item-title class="list-menu-title">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                link
                :to="child.link"
                v-show="child.show"
                @click="gotopage(child.link)"
                active-class="navbar-menu-selected"
                class="pl-8"
              >
                <v-list-item-action v-if="child.icon" class="mr-0">
                    <!-- <v-icon>{{ child.icon }}</v-icon> -->
                    <v-icon>mdi-circle-small</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title active-class="list-menu-active">
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="item.text"
              link
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="list-menu">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
    </v-navigation-drawer>
    <v-app-bar app elevate-on-scroll dense elevation="0" color="#F8F9FA" height=52 style="z-index: 100;">
      <v-app-bar-nav-icon class="ml-1" v-if="$route.name !== 'manageParticipationView'" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer />
      <!-- ปิดไว้ -->
      <!-- <div class="mt-0 mr-2" v-if="titleRole !== '' && $route.name !== 'manageParticipationView'">
        <span class="text-xs-center">Role: </span>
      </div> -->
      <!-- manageapproveview -->
      <!-- v-if="!showSelectRoleLeader" -->
      <!-- <div class="text-center d-flex" :style="$vuetify.breakpoint.name === 'xl' ? 'max-width: 10%;' : 'max-width: 14%;'" v-if="$route.name !== 'manageParticipationView'">
        <v-select
          class="role-select mt-3"
          v-model="selectRole"
          :items="roleItem"
          item-text="permission"
          item-value="_id"
          max-height="auto"
          :menu-props="{ bottom: false, offsetY: true }"
          dense
          solo
          flat
          :disabled="manageApproveTab==1"
          @change="setRole(selectRole)"
        >
        <template v-slot:item="{ item }">
            <v-row align="end" style="max-height: 70px; max-width: 400px; margin-top: -5%;" class="pb-0">
              <v-col cols="8">
                <v-list-item-content>
                <v-list-item-title><span class="ml-1">{{item.name}}</span></v-list-item-title>
                <v-list-item-subtitle><span class="ml-1">{{item.positionName}}</span></v-list-item-subtitle>
              </v-list-item-content>
              </v-col>
              <v-col cols="3" class="">
                <v-list-item-action style="margin-right: 0px;">
                <v-chip
                  class="ma-0 mr-0"
                  color="#EFF4FD"
                >
                  {{item.permission}}
                </v-chip>
              </v-list-item-action>
              </v-col>
            </v-row>
          </template>
          <template v-slot:prepend-item>
            <v-list-item
              ripple
            >
              <v-list-item-content>
                <v-list-item-title>
                  เลือกตำแหน่ง
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-0"></v-divider>
          </template>
        </v-select>
      </div> -->
      <!-- <div class="text-center d-flex" v-if="titleRole === 'Me' && !showSelectRoleLeader">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="300"
          :nudge-top='-10'
          max-width="350"
          left
          offset-y
          origin='left'
          tile
          z-index="10"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="btn-menu"
              v-bind="attrs"
              v-on="on"
              outlined
              :disabled="itemsStep1.length === 0"
              @click="repick()"
            >
              {{titleRole}}
            <v-icon
              color="grey lighten-1"
            >
              mdi-chevron-down
            </v-icon>
            </v-btn>
          </template>
          <v-card class="pt-3 pl-3 pr-3 pb-0 mx-auto mt-0 menus-scroll1" style="max-height: 300px; overflow-y: auto; overflow-x: hidden;">
            <v-row class="pt-0">
              <v-col cols="12" class="pt-0 pb-0 ma-0">
                <span class="text-center" style="font-size: 18px; color: #757575">ชื่อบริษัท</span>
              </v-col>
            </v-row>
            <v-row>
              <v-divider></v-divider>
            </v-row>
            <v-menu
              v-model="menu2"
              :close-on-content-click="true"
              :nudge-width="250"
              :nudge-top='"40vh"'
              :nudge-right='-352'
              max-width="350"
              class="d-flex"
              bottom
              left
              origin='left'
              tile
              z-index="10"
            >
              <template v-slot:activator="{ on, attrs }">
              <v-list-item
                v-for="(item, index) in itemsStep1"
                :key="index"
                link
                dark
                :style="`border-bottom: 1px inset #CCCCCC; margin-left: -12px; margin-right: -12px; background-color: ${pick1==(index+1)? '#DCDCDC':'white'};`"
                @click="getOrgchartList(index)"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-title class="ma-0 pa-0 black--text" style="font-size: 12px;" v-text="item[index].name"></v-list-item-title>
                <v-list-item-icon>
                  <v-icon
                    v-if="item[index].permission.length !== 0"
                    color="grey lighten-1"
                    size="18"
                  >
                    mdi-arrow-right
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
              </template>
                <v-card class="pa-0 mx-auto mt-0 menus-scroll1" style="max-height: 300px; overflow-y: auto; overflow-x: hidden;">
                  <v-row class="pt-0">
                    <v-col cols="12" class="pt-3 ml-3 pb-0 ma-0">
                      <span class="text-center" style="font-size: 18px; color: #757575">ตำแหน่ง</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-divider></v-divider>
                  </v-row>
                  <v-list-item
                    v-for="(item2, index2) in itemsStep2"
                    :key="index2"
                    link
                    @click="setRole(item2.role), setApproveRole(item2.role)"
                    style="border-bottom: 1px inset #CCCCCC;"
                  >
                    <v-list-item-content class="">
                      <v-list-item-subtitle
                        class="text--primary"
                        style="font-size: 12px!important;"
                        v-text="item2.orgchartName"
                      ></v-list-item-subtitle>
                      <v-list-item-subtitle
                        class="text--primary"
                        v-text="item2.position"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-chip
                        class="ma-0"
                        color="#EFF4FD"
                      >
                        {{item2.role}}
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </v-card>
              </v-menu>
          </v-card>
        </v-menu>
      </div> -->
      <!-- สิ้นสุด -->
      <!-- <div class="mt-0 mr-2" v-if="showSelectRoleLeader">
        <span class="text-xs-center">Role:</span>
      </div>
      <div class="" v-if="showSelectRoleLeader" :style="$vuetify.breakpoint.name === 'xl' ? 'max-width: 10%;' : 'max-width: 14%;'">
        <v-select
          v-if="this.$store.state.user.checkAdmin"
          v-model="selectedRole"
          class="mt-3"
          :items="roleLeader"
          dense
          solo
          @change="setApproveRoleLeader"
          :disabled="manageApproveTab==1"
        ></v-select>
        <span v-else class="text-xs-center" style="border: 0px solid grey; width: 120px; height: 38px; margin-top: 0px;">Leader</span>
      </div> -->
      <!-- ปิดไว้ -->
      <!-- <v-divider
        v-if="titleRole !== '' && this.$route.name !== 'manageParticipationView'"
        class="ml-4 mr-4"
        inset
        vertical
      ></v-divider> -->
      <!-- สิ้นสุด -->
      <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="pa-2"
              style="display: flex; flex-direction: row;background: transparent !important;align-items: center;"
            >
              <v-avatar
                class="hidden-sm-and-down mr-5"
                size="32"
                item
                rounded
              >
                <v-img
                  :src="failed_image? require('@/assets/icons/no_user.png') : imgUser"
                  :alt="userEmployeeID.toString()"
                  v-on:error="onImgError"
                ></v-img>
              </v-avatar>
              <span class="hidden-sm-and-down name-user">{{name}}</span>
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </div>
          </template>
          <v-list class="box-user">
            <v-list-item
              v-for="(item, index) in itemsUser"
              :key="index"
            >
              <v-list-item-title class="list-user" style="color: #333;">{{ item.title }}</v-list-item-title>
            </v-list-item>
            <v-btn text style="width: 100%;" class="label-logout" color="#333" @click="goLogin">Sign out</v-btn>
          </v-list>
        </v-menu>
    </v-app-bar>

    <!-- <v-main>
    </v-main> -->
    <div id="app">
      <main id="page-wrap">
        <!-- <div class="pa-5"> -->
          <router-view></router-view>
        <!-- </div> -->
      </main>
    </div>
    <OverlayLoading :loading="loading" />
  </v-app>
</template>

<script>
import { hostImageUrlv3, getUserAuth, getMenuPermission } from '@/API/API'
import OverlayLoading from '../_template/OverlayLoading.vue'
import { EventBus } from '@/EventBus'
// import { Slide } from 'vue-burger-menu'

export default {
  props: {
    source: String
  },
  components: {
    OverlayLoading
    // Slide
  },
  data: () => ({
    menu: false,
    menu2: false,
    dialog: false,
    showStep1: false,
    showStep2: false,
    drawer: false,
    itemsUser: [],
    items: [],
    isAdmin: false,
    name: '',
    userEmployeeID: '',
    imageUser: null,
    failed_image: false,
    loading: false,
    // selectedRole: (this.$store.state.user.checkAdmin ? 'Admin' : 'Leader'),
    selectedRole: '',
    roleList: [],
    pathname: '',
    pageOnUse: ['/manageapprove', '/managestructureapprove', '/managerole'],
    pageOnUseLeader: ['/manageapprove'],
    titleRole: localStorage.approveRole,
    listRole: [{
      _id: '1',
      name: 'admin'
    },
    {
      _id: '2',
      name: 'user'
    }
    ],
    selectRole: 0,
    // selectRole: localStorage.approveRole === 'Super Admin' ? 1 : localStorage.approveRole === 'Admin' ? 2 : 3,
    activeSet: false,
    selectedStep1: '',
    itemsStepAll: [],
    itemsStep1: [],
    selectedStep2: '',
    itemsStep2: [],
    pick1: 0,
    pick2: 0,
    roleLeader: ['Admin', 'Leader'],
    roleItem: [
      { header: 'INET' },
      { _id: '1', name: 'สิทธิส่วนบุคคล', group: 'Manager', positionName: 'Software Engineer', permission: 'Admin' },
      { _id: '2', name: 'สิทธิส่วนบุคคล 2', group: 'Business', positionName: 'Software Engineer', permission: 'User' },
      // { divider: true },
      { header: 'OGS' },
      { _id: '3', name: 'สิทธิ', group: 'Manager', positionName: 'Software Engineer', permission: 'User' },
      { _id: '4', name: 'สิทธิ 2 ', group: 'Manager', positionName: 'Software Engineer', permission: 'Super Admin' }
    ],
    manageApproveTab: 0
  }),
  async created () {
    // console.log('Page name', this.$route.name)
    this.pathname = window.location.pathname
    if (!this.$store.state.token) {
      this.goLogin()
    } else {
      // console.log('chk name', this.$route.name)
      // this.setApproveRole()
      if (this.$route.name === 'manageParticipationView' || this.$route.name === 'manageparticipation') {
      } else {
        // console.log('chk name ELSE', this.$route.name)
        await this.getUserDataFromAPI()
        await this.initUserData()
        this.items = []
        await this.getNavbarMenuPermission()
        // this.isAdmin = (this.$store.state.user.role).includes('administrator')
        this.roleList = this.$store.state.user.role
        this.selectedRole = localStorage.manageapproveRole === 'Admin' ? 'Admin' : 'Leader'
        // this.roleList = ['User']
        // if (this.roleList.indexOf('Super Admin') !== -1) this.roleList[this.roleList.indexOf('Super Admin')] = 'Admin'
        // this.selectedRole = this.roleList[0]
        // this.selectedRole = this.roleList[0]
        await this.setApproveRole()
      }
    }
  },
  mounted () {
    this.drawer = this.$route.name === 'manageParticipationView' ? false : null
    EventBus.$on('detailCompany', this.getUserDataFromAPI)
    var self = this
    EventBus.$on('hideNavbar', function () {
      self.drawer = false
      EventBus.$emit('hideNavbarDone')
    })
    EventBus.$on('updateNavbarRole', this.updateNavbarRole)
  },
  computed: {
    imgUser () {
      return this.failed_image ? require('@/assets/icons/no_user.png') : this.imageUser
    },
    currentPage () {
      return this.$route.path
    },
    showSelectRole () {
      return this.pageOnUse.includes(this.pathname)
    },
    showSelectRoleLeader () {
      return this.pageOnUseLeader.includes(this.pathname)
    }
  },
  watch: {
    async $route (to, from) {
      this.pathname = window.location.pathname
      await this.getUserDataFromAPI()
      await this.getNavbarMenuPermission()
      // await this.setApproveRole()
    }
    // menu (value) {
    //   console.log('select1', value)
    // },
    // menu2 (value) {
    //   console.log('select2', value)
    // }
  },
  methods: {
    getOrgchartList (indexI) {
      this.pick1 = indexI + 1
      this.itemsStep2 = []
      for (let index = 0; index < this.itemsStepAll[indexI].permission.length; index++) {
        this.itemsStep2.push({
          orgchartName: this.itemsStepAll[indexI].permission[index].name,
          role: this.itemsStepAll[indexI].permission[index].type.typeName,
          position: this.itemsStepAll[indexI].permission[index].positionName
        })
      }
    },
    repick () {
      this.pick1 = 0
    },
    async setRole (value) {
      this.titleRole = ''
      const itemChekc = this.roleItem.filter(e => e._id === value)
      this.titleRole = itemChekc[0].permission
      this.activeSet = false
      this.menu = false
      await this.setApproveRole()
    },
    updateNavbarRole (value, tab) {
      localStorage.setItem('manageapproveRole', value)
      this.selectedRole = value
      this.manageApproveTab = tab
    },
    async setApproveRole (value) {
      // console.log('pathname', this.pathname)
      // console.log('pathname role', this.selectedRole)
      // console.log('title role', this.titleRole)
      // console.log('pageOnUse', this.pageOnUse)
      // if (this.pageOnUse.includes(this.pathname)) localStorage.setItem('approveRole', this.titleRole)
      // else localStorage.setItem('approveRole', '')
      localStorage.setItem('approveRole', this.titleRole)
      localStorage.setItem('approveRoleSelect', this.selectRole)
      this.setApproveRoleLeader()
      EventBus.$emit('setApproveRole')
    },
    setApproveRoleLeader () {
      this.selectedRole = this.titleRole === 'User' ? 'Leader' : 'Admin'
      if (this.pageOnUseLeader.includes(this.pathname)) localStorage.setItem('manageapproveRole', this.selectedRole)
      else localStorage.setItem('manageapproveRole', '')
      EventBus.$emit('manageapproveRoleChange')
    },
    gotopage (link) {
      // console.log(link)
      // this.$router.push(link)
    },
    async getUserDataFromAPI () {
      var self = this
      const obj = {
        // companyId: self.$store.state.user.companyId
        companyId: null
      }
      try {
        const res = await getUserAuth(self.$store.state.token, obj)
        if (res.success) {
          this.itemsStepAll = []
          this.itemsStep1 = []
          this.itemsStepAll = res.result.role
          this.roleItem = res.result.role
          this.selectRole = res.result.role[1]._id
          const itemChekc = this.roleItem.filter(e => e._id === res.result.role[1]._id)
          // this.titleRole = itemChekc[0].permission
          // this.titleRole = res.result.role[0].permission[0].type.typeName
          if (localStorage.approveRoleSelect) this.selectRole = parseInt(localStorage.approveRoleSelect === '' || localStorage.approveRoleSelect === undefined || localStorage.approveRoleSelect === 'NaN') ? 1 : parseInt(localStorage.approveRoleSelect)
          else this.selectRole = 1
          if (localStorage.approveRole) this.titleRole = localStorage.approveRole
          else this.titleRole = itemChekc[0].permission
          this.roleItem.map((el, index) => {
            if (el.header) {
              el.header = '(บริษัท) ' + el.header
            }
          })
          for (let index = 0; index < res.result.role.length; index++) {
            this.itemsStep1.push(res.result.role)
          }
          if (res.result.companyId) {
            self.$store.state.user = res.result
            if (res.result.user.role === null) { self.$store.commit('storeUser', res.result) }
            this.initUserData()
          }
        }
      } catch (error) {
      }
    },
    initUserData () {
      var self = this
      var tempItem = []
      // console.log(self.$store.state)
      self.name = `${self.$store.state.user.titleTh}${self.$store.state.user.firstNameTh} ${self.$store.state.user.lastNameTh}`
      var name = `${self.$store.state.user.titleTh}${self.$store.state.user.firstNameTh} ${self.$store.state.user.lastNameTh}`
      tempItem.push({ title: name })
      var empId = 'รหัสพนักงาน: ' + self.$store.state.user.employeeId
      tempItem.push({ title: empId })
      var positonEmp = 'ตำแหน่ง: ' + self.$store.state.user.position
      tempItem.push({ title: positonEmp })
      self.userEmployeeID = self.$store.state.user.employeeId
      self.imageUser = `${hostImageUrlv3}/${self.$store.state.user.userImg === '' ? '_' : self.$store.state.user.userImg}/${self.$store.state.user.emailOneId}`
      self.itemsUser = tempItem
    },
    onImgError (event) {
      this.failed_image = true
    },
    goLogin () {
      // if (window.history.length) {
      //   console.log(window.history.length)
      //   var Backlen = window.history.length - 2
      //   console.log(Backlen)
      //   this.$router.go(-Backlen)
      // } else {
      // }
      this.loading = true
      setTimeout(() => {
        localStorage.setItem('targetpath', '')
        localStorage.setItem('addedFriendOneChat', '')
        localStorage.setItem('Level', '')
        this.$store.commit('clearToken')
        this.$store.commit('clearUser')
        this.loading = false
        this.$router.push('/login')
      }, 2000)
    },
    async getNavbarMenuPermission () {
      var self = this
      try {
        const res = await getMenuPermission(self.$store.state.token)
        if (res.success) {
          self.items = res.result.filter(e => e.model === true)
          const allPermissions = []
          res.result.forEach(element => {
            if (element.children && Array.isArray(element.children)) {
              const permissionList = element.children.map(child => {
                return {
                  link: child.link,
                  permission_rights: {
                    show: child.show,
                    create: child.create,
                    edit: child.edit,
                    del: child.delete,
                    upload: child.upload,
                    download: child.download
                  }
                }
              })
              allPermissions.push(...permissionList)
            }
          })
          this.$store.commit('setPermissions', allPermissions)
          // self.items = [
          //   {
          //     icon: 'mdi-chevron-up',
          //     iconAlt: 'mdi-chevron-down',
          //     text: 'Dashboard',
          //     model: true,
          //     children: [
          //       {
          //         icon: 'mdi-view-dashboard-outline',
          //         text: 'Dashboard',
          //         link: '/dashboard',
          //         show: true
          //       }
          //     ]
          //   },
          //   {
          //     icon: 'mdi-chevron-up',
          //     iconAlt: 'mdi-chevron-down',
          //     text: 'Organization Chart',
          //     model: true,
          //     children: [
          //       {
          //         icon: 'mdi-lan',
          //         text: 'โครงสร้างองค์กร',
          //         link: '/orgchart',
          //         show: true
          //       },
          //       {
          //         icon: 'mdi-briefcase-edit-outline',
          //         text: 'จัดการอนุมัติพนักงาน',
          //         link: '/manageapprove',
          //         show: true
          //       },
          //       {
          //         icon: 'mdi-briefcase-edit-outline',
          //         text: 'จัดการเครือและบริษัท',
          //         link: '/managecompany',
          //         show: true
          //       },
          //       {
          //         icon: 'mdi-account-edit-outline',
          //         text: 'จัดการพนักงาน',
          //         link: '/manageemployee',
          //         show: true
          //       },
          //       // {
          //       //   icon: 'mdi-briefcase-edit-outline',
          //       //   text: 'รายการที่ต้องอนุมัติ',
          //       //   link: '/manageapprovelist',
          //       //   show: true
          //       // },
          //       {
          //         icon: 'mdi-wrench-outline',
          //         text: 'จัดการตำแหน่งงาน',
          //         link: '/manageposition',
          //         show: true
          //       },
          //       {
          //         icon: 'mdi-account-edit-outline',
          //         text: 'จัดการโครงสร้างงาน',
          //         link: '/managestructure',
          //         show: true
          //       }
          //       // {
          //       //   icon: 'mdi-wrench-outline',
          //       //   text: 'จัดการสายงาน',
          //       //   link: '/managelineofwork',
          //       //   show: true
          //       // },
          //       // {
          //       //   icon: 'mdi-wrench-outline',
          //       //   text: 'จัดการฝ่ายงาน',
          //       //   link: '/managedepartment',
          //       //   show: true
          //       // },
          //       // {
          //       //   icon: 'mdi-wrench-outline',
          //       //   text: 'จัดการส่วนงาน',
          //       //   link: '/managesection',
          //       //   show: true
          //       // },
          //       // {
          //       //   icon: 'mdi-wrench-outline',
          //       //   text: 'จัดการหน่วยงาน',
          //       //   link: '/manageagency',
          //       //   show: true
          //       // },
          //       // {
          //       //   icon: 'mdi-wrench-outline',
          //       //   text: 'จัดการกลุ่มงาน',
          //       //   link: '/manageworkgroup',
          //       //   show: true
          //       // },
          //     ]
          //   },
          //   {
          //     icon: 'mdi-chevron-up',
          //     iconAlt: 'mdi-chevron-down',
          //     text: 'Registration Authority',
          //     model: true,
          //     children: [
          //       {
          //         icon: 'mdi-playlist-edit',
          //         text: 'รายการ services',
          //         link: '/authorityservices/myservicelist',
          //         show: true
          //       },
          //       {
          //         icon: 'mdi-list-status',
          //         text: 'รายการร้องขอใช้บริการ',
          //         link: '/authorityservices/requestservicelist',
          //         show: true
          //       },
          //       {
          //         icon: 'mdi-wrench-outline',
          //         text: 'ตั้งค่า services',
          //         link: '/settingservices',
          //         show: true
          //       }
          //     ]
          //   },
          //   {
          //     icon: 'mdi-chevron-up',
          //     iconAlt: 'mdi-chevron-down',
          //     text: 'User & Role Management',
          //     model: true,
          //     children: [
          //       {
          //         icon: 'mdi-wrench-outline',
          //         text: 'จัดการสิทธิ์ตามบริษัท',
          //         link: '/managerolecompany',
          //         show: true
          //       },
          //       {
          //         icon: 'mdi-wrench-outline',
          //         text: 'Role Management',
          //         link: '/managerole',
          //         show: true
          //       }
          //     ]
          //   }
          // ]
          if (self.items.length > 0) {
            localStorage.setItem('mainpage', self.items[0].children[0].link)
          } else {
            localStorage.setItem('mainpage', '')
          }
        }
      } catch (error) {
        this.$store.commit('clearPermissions')
      }
    }
  }
}
</script>

<style scoped>
/* @import "../../css/Navbar.css"; */
  @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@400&display=swap');
.toobal-change-color {
  /* background: rgb(132,55,140);
  background: linear-gradient(90deg, rgba(132,55,140,1) 0%,  rgb(221,72,141) 100%); */
  background: #004682;
  background: linear-gradient(90deg, #07D1BF 0%, #004682 100%);
}
.title-page {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Spartan', sans-serif !important;
  font-weight: 700 !important;
  font-size: 2rem;
}
.name-user {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1rem;
}
.list-user {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}
.list-menu-title {
  font-family: 'Sarabun', sans-serif;
  font-weight: 600 !important;
  font-size: 14px !important;
}
/* active ในส่วนของ icon กลมๆ */
.v-list .v-list-item--active {
  color: #2BA197 !important;
  background-color: white !important;
  opacity: 1;
  margin-left: 20px;
  margin-right: 20px;
}

/* .list-active {
  border-left: red 16px !important;
}

.list-inactive {
  color: pink !important;
} */

.v-application .primary--text {
  /* color: #4CB050!important; */
  color: #FFFFFF !important;
}
.list-menu {
  font-family: 'Sarabun', sans-serif !important;
  /* font-weight: normal; */
  font-size: 14px;
  /* margin-left: -18%; */
  /* color: #333 !important; */
  color: #FFFFFF !important;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;

}
.v-list-item {
  align-items: center;
  display: flex;
  flex: 1 1 100%;
  letter-spacing: normal;
  min-height: 24px;
  outline: none;
  /* padding: 0 16px; */
  /* margin-left: -18%; */
  position: relative;
  text-decoration: none;
}
.label-logout {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 14px;
}
.box-user {
  background-color: #fff;
  /* background: #07D1BF !important;
  background: linear-gradient(360deg, #07D1BF 0%,  #004682 100%) !important; */
}
/* มีการเลือกเมนูนั้นๆ */
.navbar-menu-selected {
  /* padding-left: 11px; */
  /* border-left: 5px solid #F2CE64; */
  /* background-color: #F6911F; */
  border-radius: 8px;
  padding-left: 12px !important;
}
.navbar-menu-selected-icon {
  color: red !important;
}
.btn-menu {
    cursor: pointer;
    border: 1px solid gray;
    background-color: transparent;
    /* height: 50px;
    width: 200px; */
    color: black;
    font-size: 0.7em;
    /* box-shadow: 0 6px 6px rgba(0, 0, 0, 0.6); */
}
.menus-scroll {
  /* background-color: lightblue; */
  height: 200px;
  overflow: auto;
}

.v-select .v-subheader {
  color: red;
  font-size: 25px;
}
.v-list--dense .v-subheader{
    font-size: 0.75rem!important;
    height: 40px!important;
    padding: 0 8px!important;
    color: red!important;
}

.v-menu__content {
   margin-top: -6px;
}

.role-select {
  border: 1px solid gray;
  height: 40px;
  margin-bottom: 14px;
}
.name-logo {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 16px;
}
.v-list--dense .v-list-item .v-list-item__icon {
    margin-right: 10px !important;
}
.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: auto !important;
    justify-content: flex-end;
    margin-left: 0px !important;
}
/* .v-list-item__title--active {
  color: black !important;
} */
</style>
